
import { defineComponent } from "vue";
import UploadPicture from "./UploadPicture.vue";

export default defineComponent({
  name: "UploadVirtual",
  components: { UploadPicture },
  emits: ["change"],
});
